var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"page-app-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/logo.png")}}),_c('span',{staticClass:"logo-name hidden-xs-only"},[_vm._v("秀动管理后台")])])}
var staticRenderFns = []

export { render, staticRenderFns }